import { IMediaItem } from '@/lib/types/media'
import { cn } from '@/lib/utils'
import { MediaThumbnail } from './MediaThumbnail'

interface UploadState {
  isUploading: boolean
  isProcessing: boolean
  progress: number
  error?: string | null
  previewUrl?: string
}

interface ThumbnailGalleryProps {
  media: (IMediaItem & { id: string; previewUrl?: string })[]
  selectedIndex: number
  onSelect: (index: number) => void
  uploadStates?: Record<string, UploadState>
  className?: string
}

export function ThumbnailGallery({
  media,
  selectedIndex,
  onSelect,
  uploadStates = {},
  className
}: ThumbnailGalleryProps) {
  return (
    <div className={cn('flex gap-2 overflow-x-auto', className)}>
      {media.map((item, index) => (
        <MediaThumbnail
          key={item.id}
          media={item}
          isSelected={index === selectedIndex}
          onSelect={() => onSelect(index)}
          uploadState={uploadStates[item.id]}
        />
      ))}
    </div>
  )
}
